import { callFirebaseFunction } from '@/core/services';
import { CLOUD_FUNCTION_SEND_WHATSAPP_TEST_MESSAGE } from '@/core/config/firebase-functions';

export type SendWhatsAppTestMessageInput = {
  /** Ex: `5511999999999` (E.164 sem `+`). */
  to: string;
};

export type SendWhatsAppTestMessageResponse = {
  message_id: string;
};

export async function sendWhatsAppTestMessage(
  input: SendWhatsAppTestMessageInput
): Promise<SendWhatsAppTestMessageResponse> {
  return callFirebaseFunction<SendWhatsAppTestMessageInput, SendWhatsAppTestMessageResponse>(
    CLOUD_FUNCTION_SEND_WHATSAPP_TEST_MESSAGE,
    input
  );
}

